<div class="cabinet">
  @if (isShowSidebar()) {
    <app-sidebar
      class="cabinet__sidebar"
      [@enterAnimation]
      [projectList]="projectList()"
      [taskOpenId]="taskOpenId()"
      [projectSelectedId]="projectSelectedId()"
    />
  }

  <div class="cabinet__wrapper">
    <app-header [isShowSidebar]="isShowSidebar()" />

    <div class="cabinet__content">
      <div class="cabinet__work">
        <router-outlet />
      </div>

      <div class="cabinet__sidebar-left">
        @if (isShowSidebarFilter()) {
          <app-sidebar-filter class="cabinet__sidebar-filter" [inviteList]="inviteList()" />
        } @else {
          <app-sidebar-user class="cabinet__sidebar-user" [inviteList]="inviteList()" />
        }
      </div>
    </div>
    <router-outlet name="task" />
  </div>
</div>

@if (popupProjectMenu().isOpen) {
  <app-project-menu [style.bottom.px]="popupProjectMenu().position" />
}
@if (popupProjectForm().isOpen) {
  <app-project-form
    class="project-menu__project-form"
    [style.top.px]="popupProjectForm().top"
    [style.left.px]="popupProjectForm().left"
  />
}
@if (imageService.isOpen) {
  <ux-image />
}
